<template>
  <div :class="!$q.platform.is.mobile ? 'q-pa-sm' : void 0">
    <q-table
            ref="table"
            :pagination.sync="server_pagination"
            :data="topics"
            :columns="columns"
            @request="requestTopics"
            :loading="loading"
            :filter="filter"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[5,10,50,100]"
            binary-state-sort
            class="shadow-0 test"
            :class="$q.platform.is.mobile ? 'custom-space' : void 0"
            >

            <template slot="top" slot-scope="props" :props="props">
                <div class="col-4 col-xs-12 col-sm-6 col-md-4">
                    <q-search v-model="filter" icon="fas fa-search" :placeholder="$t('search')" :debounce="500" />
                </div>
                <div class="col-3 col-xs-12 col-sm-6 col-md-4" :class="!$q.platform.is.mobile ? 'q-ml-md' : ''">
                    <q-option-group color="primary" class="radio" v-model="unanswered" @input="fetchLists"
                        :options="[{ label: $t('all_f'), value: false }, { label: $t('unanswered'), value: true }]"
                    />
                </div>

                <div class="col-2 col-xs-12 col-sm-4 col-md-3 q-my-sm">
                    <q-btn style="height: 2.572em;" :class="$q.platform.is.mobile ? '' : 'absolute-right'" color="primary" icon="far fa-comment" :label="$t('new_topic')" @click="showNewTopicModal" />
                </div>
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props" class="cursor-pointer" @click.native="showTopicModal(props.row)">
                    <q-td key="topic" :props="props">
                        {{ props.row.topic.length > 49 ? `${props.row.topic.substring(0,50)}...` : props.row.topic  }}
                        <q-tooltip>{{ props.row.topic }}</q-tooltip>
                    </q-td>

                    <q-td key="qty_answers" :props="props">
                        {{ props.row.qty_answers }}
                    </q-td>

                    <q-td key="author" :props="props">
                        {{ props.row.author.length > 24 ? `${props.row.author.substring(0,25)}...` : props.row.author  }}
                    </q-td>

                    <q-td key="updated_date" :props="props">
                        {{ props.row.updated_date }}
                    </q-td>

                </q-tr>
            </template>
        </q-table>

        <new-topic-modal :show="show_new_topic_modal" @hideModal="hideModal()" />
        <topic-modal v-if="show_topic_modal" :topic="topic" :show="show_topic_modal" @hideModal="hideModal()" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'

export default {
    data() {
        return {
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            loading: false,
            columns: [
                {
                    name: 'topic',
                    required: true,
                    label: 'topic',
                    align: 'left',
                    field: 'topic',
                    sortable: false,
                },
                {
                    name: 'qty_answers',
                    required: true,
                    label: 'replies',
                    align: 'left',
                    field: 'qty_answers',
                    sortable: false,
                },
                {
                    name: 'author',
                    required: true,
                    label: 'author',
                    align: 'left',
                    field: 'author',
                    sortable: false,
                },
                {
                    name: 'updated_date',
                    required: true,
                    label: 'updated_date',
                    align: 'left',
                    field: 'updated_date',
                    sortable: false,
                }
            ],
            filter: '',
            topic: [],
            topics: [],
            loading: false,
            show_new_topic_modal: false,
            show_topic_modal: false,
            id_curse : '',
            id_trail: '',
            unanswered: false
        }
    },

    components: {
        'new-topic-modal': () => import ('components/course/DiscussionsNewTopicModal'),
        'topic-modal': () => import('components/course/DiscussionsTopicModal')
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            num_rows: 'datatable/num_rows'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },
    },

    methods: {
        requestTopics ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "unanswered": this.unanswered,
                "search": this.filter,
                "ordering": order_by
            }

            this.savePagination()

            this.$axios.get(`/etraining_courses/group_training/${this.$route.params.id}/group_training_forum/list_all_topic/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.topics = []

                this.topics = response.data.results.map(r => {
                    return {
                        ...r,
                        updated_date: date.formatDate(r.updated_date, 'DD/MM/YYYY HH:mm'),
                        status: r.status,
                        topic: r.title,
                        report: r.report,
                        liked: r.liked,
                        likes: r.likes,
                        author: r.author.name,
                        author_id: r.author.id,
                        avatar: r.author.author_image,
                        qty_answers: r.qty_answers
                    }
                })
                // .filter(t => t.status === 1)

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fetchLists() {
            this.$q.loading.show()
            this.requestTopics({ pagination: this.server_pagination })
            this.$q.loading.hide()
        },

        showNewTopicModal() {
            this.show_new_topic_modal = true
        },

        showTopicModal(topic) {
            this.topic = topic
            this.show_topic_modal = true
        },

        hideModal() {
            this.show_new_topic_modal = false
            this.show_topic_modal = false
            this.topic = []
            this.fetchLists()
        },

        savePagination() {
            this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
        },

        loadPagination() {
            this.server_pagination.rowsPerPage = this.num_rows
        }
    },

    created() {
        this.loadPagination()
        this.fetchLists()
    }
}
</script>

<style lang="stylus" scoped>
.custom-space {
    td {
        line-height 2.5rem
    }
}
.radio {
    color #9a9797
    font-size 90%
    font-weight 400
}
</style>
